<template>
    <section class="section">
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <h1 v-t="'Dashboard.folders_title'" class="title"></h1>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <button
                        v-t="'Project.new_folder'"
                        class="
                            button
                            is-white
                            has-text-primary
                            is-medium is-uppercase is-size-6
                        "
                        @click="createFolder"
                    ></button>
                </div>
            </div>
        </div>
        <div class="columns is-multiline is-mobile mx-0">
            <div
                v-for="folder in folders"
                :key="folder._id"
                class="
                    column
                    is-12-mobile is-6-tablet is-4-widescreen
                    lb-project-card
                "
                @dragenter.prevent
                @dragover.prevent
                @drop="handleDrop($event, folder)"
            >
                <dashboard-folder
                    :folder="folder"
                    @edit="editFolder"
                    @delete="deleteFolder"
                />
            </div>
        </div>
    </section>
</template>

<script>
import { createItem, fetchItems, deleteItem, updateItem } from '@/services/API';
import DashboardFolder from '@/components/DashboardFolder';
import _ from 'underscore';
export default {
    components: {
        DashboardFolder,
    },
    data() {
        return {
            folders: [],
        };
    },
    mounted() {
        this.fetchFolders();
    },
    methods: {
        handleDrop(ev, folder) {
            var project = ev.dataTransfer.getData('project');
            this.$emit('addProject', project, folder);
        },
        async fetchFolders() {
            const folders = await fetchItems('folder');
            this.folders = folders.data;
        },
        async createFolder() {
            let name = window.prompt(
                this.$t('Folders.create_folder'),
                undefined
            );
            if (!name || !name.length) {
                return;
            }
            const response = await createItem('folder', { name });
            await this.fetchFolders();
        },
        async deleteFolder(item) {
            if (confirm(this.$t('delete_folder_confirmation_message'))) {
                let response = await deleteItem('folder', item._id);
                if (response.data == 'SUCCESS') {
                    console.log('removing item', item._id);
                    this.folders = _.filter(this.folders, (folder) => {
                        return folder._id != item._id;
                    });
                } else {
                    console.error('impossible to delete folder');
                }
                console.log(item);
            }
        },
        async editFolder(folder) {
            let name = window.prompt(
                this.$t('Folders.create_folder'),
                folder.name
            );
            console.log({ name });
            if (!name || !name.length) {
                return;
            }
            folder.name = name;
            const response = await updateItem('folder', folder._id, folder);
            console.log(response.data);
            await this.fetchFolders();
        },
    },
};
</script>

<style scoped>
/deep/.lb-folder-box {
    width: auto;
}
</style>
